/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The TerminalBox component
 *
 * @author Thais Watanabe
 */
const TerminalBox = (props) => {
  const {
    turbineInspection,
    title,
    inspectionModel,
    result,
    openEdit,
    openObs,
    isPastInspection,
    inspection,
    lastTurbineInspections,
  } = props;

  return (
    <Table>
      <thead>
        <tr>
          <ColHeader id={inspectionModel?.name} className="w-10 text-center print:hidden">
            {!isPastInspection && (
              <ResultDropdown
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={inspectionModel}
                turbineInspection={turbineInspection}
                selectedResult={result}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
            )}
          </ColHeader>
          <ColHeader className="text-center" colSpan={19}>
            {title}
          </ColHeader>
        </tr>
        <tr>
          <ColHeader className="text-center print:hidden"></ColHeader>
          <ColHeader className="text-center">位置</ColHeader>
          <ColHeader className="text-center">試験電圧</ColHeader>
          <ColHeader className="text-center">
            1分平均値
            <br />
            絶縁抵抗値
          </ColHeader>
          <ColHeader className="text-center">
            10分平均値
            <br />
            絶縁抵抗値
          </ColHeader>
          <ColHeader className="text-center">印加電圧</ColHeader>
          <ColHeader className="text-center">コイル温度</ColHeader>
          <ColHeader className="text-center">室温</ColHeader>
          <ColHeader className="text-center">湿度</ColHeader>
        </tr>
      </thead>
      <TableBody>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">M-E間</Col>
          <Col className="text-center" rowSpan={3}>
            1000V
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[4] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[4].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[4] ?? "-",
                4
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[7] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[7].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[7] ?? "-",
                7
              )}
            />
          </Col>
          <Col className="text-center" rowSpan={3}>
            <ResultBadge
              result={result?.childrenResults[0] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[0].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[0] ?? "-",
                0
              )}
            />
          </Col>
          <Col className="text-center" rowSpan={3}>
            <ResultBadge
              result={result?.childrenResults[1] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[1].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[1] ?? "-",
                1
              )}
            />
          </Col>
          <Col className="text-center" rowSpan={3}>
            <ResultBadge
              result={result?.childrenResults[2] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[2].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[2] ?? "-",
                2
              )}
            />
          </Col>
          <Col className="text-center" rowSpan={3}>
            <ResultBadge
              result={result?.childrenResults[3] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[3].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[3] ?? "-",
                3
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">S-E間</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[5] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[5].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[5] ?? "-",
                5
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[8] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[8].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[8] ?? "-",
                8
              )}
            />
          </Col>
        </tr>
        <tr>
          <Col className="text-center print:hidden"></Col>
          <Col className="text-center">巻線M-S間</Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[6] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren.items?.[6].unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[6] ?? "-",
                6
              )}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={result?.childrenResults[9] ?? "-"}
              unit={
                inspectionModel?.inspectionModelItemChildren?.items?.[9]?.unit
              }
              isInputCorrect={isInputCorrect(
                inspectionModel?.name,
                result?.childrenResults[9] ?? "-",
                9
              )}
            />
          </Col>
        </tr>
      </TableBody>
    </Table>
  );
};

export default TerminalBox;
